<script lang="ts">
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';

	import { user_data } from 'src/stores/account/user';
	import { scrollToPremiumSubs } from 'src/stores/ui/promotions';

	import { ButtonV2, Icon, LineContainer, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { ComponentVariant } from '@Shelly/shelly-design-system/helpers/enums';

	import { capFirstChar } from 'src/helpers/utilities';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';

	export let isMobile = false;

	$: isSharedHome = isActiveHomeShared();

	$: isPremium = $user_data?.premium;
	$: title = isPremium
		? $format('premium', { default: 'Premium' })
		: $format('type_push', { default: 'Standard' });
	$: icon = isPremium && 'fas fa-gem icon-premium-color';
	let buttonProps: {
		title: string;
		type: `${ComponentVariant.PREMIUM}` | `${ComponentVariant.PRIMARY}`;
	} = {
		title: $format('export_premium_heading', {
			default: 'Explore Premium',
		}),
		type: `${ComponentVariant.PREMIUM}`,
	};

	$: {
		if (isPremium) {
			buttonProps.title = $format('export_premium_heading', {
				default: 'Explore Premium',
			});
			buttonProps.type = `${ComponentVariant.PREMIUM}`;
		} else {
			buttonProps.title = $format('upgrade_plan_heading', {
				default: 'Upgrade plan',
			});
			buttonProps.type = `${ComponentVariant.PRIMARY}`;
		}
	}

	$: premiumUrl = '/settings/premium';

	const onBtnClick = () => {
		if (!isPremium) {
			$scrollToPremiumSubs = true;
		}
		push(premiumUrl);
	};
</script>

<LineContainer
	accentColor={isPremium ? '--gradient-premium' : '--gradient-primary-horizontal'}
	class={classMap({
		'd-flex flex-direction-column justify-content-between bg-color-00': true,
		'width-full': isMobile,
	})}
>
	<div class="d-flex flex-direction-column width-full flex-1">
		<div
			class={classMap({
				'd-flex align-items-start': true,
				'gap-s': isPremium,
			})}
		>
			<Text
				class={classMap({
					'text-normal text-nowrap': true,
					'icon-premium-color': isPremium,
					'text-primary': !isPremium,
				})}
				styleType="h1"
			>
				{capFirstChar(title)}
			</Text>
			{#if icon}
				<Icon size="s" {icon} />
			{/if}
		</div>
		<Text styleType="tiny" class="text-color-muted text-normal mt-xxs">
			{$format('current_plan_heading', {
				default: 'Current plan',
			}).toUpperCase()}
		</Text>
	</div>

	<div
		class={classMap({
			'd-flex mt-m': true,
			'flex-nowrap gap-m align-items-center': !isMobile,
			'flex-direction-column align-items-start gap-s': isMobile,
		})}
		slot="footer"
	>
		{#if !isSharedHome}
			<ButtonV2 class="text-nowrap" on:click={onBtnClick} size="m" variant={buttonProps?.type}>
				{buttonProps?.title}
			</ButtonV2>
			<Text
				href="/"
				class={classMap({
					'link-underline': true,
					'text-nowrap': !isMobile,
				})}
				styleType="controls-small"
				on:click={(e) => {
					e.preventDefault();
					push(premiumUrl);
				}}
			>
				{$format('redeem_voucher_prompt', { default: 'Redeem voucher' })}
			</Text>
		{/if}
	</div>
</LineContainer>
